var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5556 9.28571V7.14286C17.5556 6.57454 17.3214 6.02949 16.9047 5.62763C16.4879 5.22576 15.9227 5 15.3333 5H4.22222C3.63285 5 3.06762 5.22576 2.65087 5.62763C2.23413 6.02949 2 6.57454 2 7.14286V13.5714C2 14.1397 2.23413 14.6848 2.65087 15.0867C3.06762 15.4885 3.63285 15.7143 4.22222 15.7143H6.44444M8.66667 20H19.7778C20.3671 20 20.9324 19.7742 21.3491 19.3724C21.7659 18.9705 22 18.4255 22 17.8571V11.4286C22 10.8602 21.7659 10.3152 21.3491 9.91334C20.9324 9.51148 20.3671 9.28571 19.7778 9.28571H8.66667C8.0773 9.28571 7.51207 9.51148 7.09532 9.91334C6.67857 10.3152 6.44444 10.8602 6.44444 11.4286V17.8571C6.44444 18.4255 6.67857 18.9705 7.09532 19.3724C7.51207 19.7742 8.0773 20 8.66667 20ZM16.4444 14.6429C16.4444 15.2112 16.2103 15.7562 15.7936 16.1581C15.3768 16.5599 14.8116 16.7857 14.2222 16.7857C13.6329 16.7857 13.0676 16.5599 12.6509 16.1581C12.2341 15.7562 12 15.2112 12 14.6429C12 14.0745 12.2341 13.5295 12.6509 13.1276C13.0676 12.7258 13.6329 12.5 14.2222 12.5C14.8116 12.5 15.3768 12.7258 15.7936 13.1276C16.2103 13.5295 16.4444 14.0745 16.4444 14.6429Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalPayments);
export default __webpack_public_path__ + "static/media/externalPayments.54876be488f9471aee203ed3d8207ab4.svg";
export { ForwardRef as ReactComponent };